import { VendorSalesPage } from "@/features/vendor-app/pages/VendorSalesPage";
import { createFileRoute } from "@tanstack/react-router";

export type VendorSalesSearch = {
	number?: string;
	dateStart?: string;
	dateEnd?: string;
	status?: string;
	branchID?: string;
	productID?: string;
};

const str = (v: unknown): string | undefined =>
	typeof v === "string" && v !== "" ? v : undefined;

export const Route = createFileRoute("/vendor/sales/")({
	validateSearch: (search: Record<string, unknown>): VendorSalesSearch => ({
		number: str(search.number),
		dateStart: str(search.dateStart),
		dateEnd: str(search.dateEnd),
		status: str(search.status),
		// Preserve "" (explicit "All branches") distinct from undefined (unset →
		// fall back to the header Current Location).
		branchID: typeof search.branchID === "string" ? search.branchID : undefined,
		productID: typeof search.productID === "string" ? search.productID : undefined,
	}),
	component: VendorSalesPage,
});
